import AlertSuccess from "components/Alert/Success";
import { useCaseStore } from "store/Case";

const Notifications = () => {
  const { debtConsolidationFormSubmitted } = useCaseStore();
  return (
    <>
      {debtConsolidationFormSubmitted && (
        <AlertSuccess title="Debt Consolidation Form Submitted" border>
          <p>Your debt consolidation form has been submitted successfully.</p>
        </AlertSuccess>
      )}
    </>
  );
};

export default Notifications;
